import { AlertCircle, CheckCircle2, Circle, Loader2 } from "lucide-react";

export type ChecklistState = "pending" | "loading" | "success" | "failed";

interface PermissionStatusProps {
  label: string;
  state: ChecklistState;
  hint?: string;
}

/** One row of the pre-interview checklist (icon + label + optional hint). */
export function PermissionStatus({ label, state, hint }: PermissionStatusProps) {
  const icon =
    state === "success" ? (
      <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" />
    ) : state === "failed" ? (
      <AlertCircle className="w-5 h-5 text-red-600 shrink-0" />
    ) : state === "loading" ? (
      <Loader2 className="w-5 h-5 text-brand-600 shrink-0 animate-spin" />
    ) : (
      <Circle className="w-5 h-5 text-slate-300 shrink-0" />
    );

  const labelColor =
    state === "success"
      ? "text-ink-900"
      : state === "failed"
        ? "text-red-700"
        : "text-ink-600";

  return (
    <div className="flex items-start gap-3">
      <span className="mt-0.5">{icon}</span>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-semibold ${labelColor}`}>{label}</p>
        {hint ? <p className="text-xs text-ink-400 mt-0.5">{hint}</p> : null}
      </div>
    </div>
  );
}
